import { Request } from "./request";

export const apiAnswerCustomClue = async (clue_id: number | undefined) => {
  return Request.call({
    url: `/api/clue/${clue_id}/custom-clue-answer`,
    method: "POST",
    data: {},
  });
};
